import React from "react";
import { FiX } from "react-icons/fi";
const SearchBar = ({ value, onChange, placeholder = "Search..." }) => {
  return (
    // <input
    //   type="text"
    //   value={value}
    //   onChange={(e) => onChange(e.target.value)}
    //   placeholder={placeholder}
    //   className="w-full sm:w-1/3 text-black border border-gray-500 rounded-lg px-4 py-2 text-sm"
    // />
    <div className="relative w-full sm:w-1/2">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full text-black border border-gray-950 rounded-lg px-4 pr-10 py-2 text-sm placeholder-gray-950"
      />

      {value && (
        <button
          onClick={() => onChange("")}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-950 hover:text-gray-600"
          aria-label="Clear search"
        >
          <FiX size={18} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
